import { FieldState } from '../models/field-state';
import {
  IValidator,
  MessageLevel,
  ValidatedField,
} from '@admin/shared/validation/validators';
import { ValidationContainer } from '@admin/shared/validation/validation-container';
import { Observable } from 'rxjs';

export class ValidationUtils {
  static invokeValidation<TField>(
    validators: IValidator[],
    fieldStates: any,
    onValid?: () => void
  ) {
    var results = { isValid: true, set: [] };
    var observable = Observable.create((observer) => {
      ValidationContainer.validate(validators, observer, results);
    });
    var result;
    var sub = observable.subscribe(
      (item) => {
        result = item.syncValidator();
        ValidationContainer.attachValidationResult(results, result, item);
      },
      (err) => {
        /*console.log("error")*/
      },
      () => {
        // console.log("validation finished.");
        ValidationUtils.applyValidationResultSet(
          results,
          validators,
          fieldStates,
          onValid
        );
      }
    );
  }

  static applyValidationResultSet(
    results,
    validators: IValidator[],
    fieldStates: any,
    onValid?: () => void
  ) {
    for (var k in results.set) {
      var fieldSet = results.set[k];
      var s = fieldStates[k];
      var isValid = fieldSet.items.length == 0;
      s.isValid = isValid;
      s.message = isValid ? null : fieldSet.items[0].message;
      s.messageLevel = isValid ? MessageLevel.Info : MessageLevel.Error;
    }
    if (results.isValid && onValid != void 0) onValid();
  }

  static generateFieldStates(fieldEnum): any {
    var fieldStates = {};
    for (var item in fieldEnum) {
      if (fieldEnum.hasOwnProperty(item) && isNaN(parseInt(item)))
        var state = new ValidatedField();
      fieldStates[item] = state;
      fieldStates[fieldEnum[item]] = state;
    }
    return fieldStates;
  }
}
